import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoutes = ({ auth }) => {
    // let auth = { 'token': false }
    return (
        auth.token ? <Outlet /> : <Navigate to='/' />
    )
}

export default PrivateRoutes